// One mounted Access Codes workspace may ask before app-controlled route exits.
// This does not intercept logout, browser history, reload or server redirects.
let currentGuard = null;

export function registerCommunityLeaveGuard(guard) {
  currentGuard = guard;
  return () => { if (currentGuard === guard) currentGuard = null; };
}

export function confirmCommunityNavigation() {
  return currentGuard ? currentGuard() : true;
}
